import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, Badge, Container } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import { getCartItems } from '../../../Cart/CartActions';
import { APP_VERSION_CHECK_INTERVAL_MS, checkVersionRequest, initPersistedData, initApp, setRedirect } from '../../AppActions';
import { initCurrency } from '../../../Currency/CurrencyActions';
import { initLanguage } from '../../../Intl/IntlActions';
import { displayErrors, removeError } from '../../../Error/ErrorActions';
import { getUserPreference } from '../../../User/UserActions';

import withRouter from '../../../../components/Router/WithRouter';
import AppLogo from '../AppLogo';
import Menu from '../menu/Menu';

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
        };

        this.appVersionInterval = null;
    }

    componentDidMount() {
        this.props.dispatch(initPersistedData());

        // this.switchLanguage(null);

        this.props.dispatch(initApp());

        this.props.dispatch(initCurrency(this.props.user));
        this.props.dispatch(checkVersionRequest());
        this.startVersionPolling();

        if(typeof document !== 'undefined') {
            document.addEventListener('visibilitychange', this.handleVisibilityChange);
        }

        this.props.dispatch(setRedirect(this.props.search.redirect || this.props.redirectRoute || ''));

		this.addUserTrackingInformation();
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
            if(this.state.isOpen) {
                this.setState({ isOpen: false });
            }
        }

        // Update app language from user preferences
        if(!prevProps.user && this.props.user) {
            this.props.intl.locale !== getUserPreference(this.props.user, 'language') && this.switchLanguage(getUserPreference(this.props.user, 'language'));
            this.props.dispatch(initCurrency(this.props.user));
			this.addUserTrackingInformation();
        }

        // Redirect app if triggered by other component
        if(prevProps.redirectIndex !== this.props.redirectIndex && this.props.redirectRoute) {
            const redirection = this.props.redirectRoute;
            console.log('App::: Redirect to ', redirection);
            this.props.dispatch(setRedirect(''));
            if(redirection.match(/http(s)?:\/\//)) {
                window.location.href = redirection;
            } else {
                this.props.navigate(redirection);
            }
        }

        // Display or remove errors
        if(prevProps.errors.length !== this.props.errors.length) {
            this.props.errors.forEach(error => {
                if(error && error.type && error.message) {
                    displayErrors(error.type, this.props.intl.messages[`alert${error.message}`] || error.message);
                }
                this.props.dispatch(removeError(error.message));
            });
        }
    }

    componentWillUnmount() {
        this.stopVersionPolling();
        if(typeof document !== 'undefined') {
            document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        }
    }

    startVersionPolling = () => {
        this.stopVersionPolling();
        // Only poll while the tab is visible — avoids waking radios / hitting Cloudflare in background
        if(typeof document !== 'undefined' && document.visibilityState === 'hidden') {
            return;
        }
        this.appVersionInterval = setInterval(() => {
            this.props.dispatch(checkVersionRequest());
        }, APP_VERSION_CHECK_INTERVAL_MS);
    };

    stopVersionPolling = () => {
        if(this.appVersionInterval) {
            clearInterval(this.appVersionInterval);
            this.appVersionInterval = null;
        }
    };

    handleVisibilityChange = () => {
        if(typeof document === 'undefined') {
            return;
        }
        if(document.visibilityState === 'visible') {
            this.props.dispatch(checkVersionRequest());
            this.startVersionPolling();
        } else {
            this.stopVersionPolling();
        }
    };

    isLoggedIn = () => {
        return this.props.user && this.props.user._id;
    };

	addUserTrackingInformation = () => {
		if(this.props.user) {
			const userData = {
				'email': this.props.user?.email || '',
				'phone_number': this.props.user?.phone || '',
			};
			window.user = userData;
			window.dataLayer?.push({ user_data: userData });
		}
	};

    switchLanguage = lang => {
        this.props.dispatch(initLanguage(lang, this.props.user)).then(lang => {});
    };

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    closeMenu = () => {
        this.setState({ isOpen: false });
    };

    render() {
        const isLoggedIn = this.isLoggedIn();

        return (
            <div className={classNames('header-wrapper', this.state.isOpen && 'header-wrapper--menu-open')}>
                {this.state.isOpen && isLoggedIn ? (
                    <button type="button" className="header-menu-backdrop" onClick={this.closeMenu} aria-label="Close menu" />
                ) : null}
                <Container fluid="xl">
                    <Navbar color="" light expand="xl">
                        <NavbarBrand href="https://www.monlivresms.com/fr/">
                            <AppLogo style={{ width: '168px', height: 'auto' }} />
                        </NavbarBrand>

                        {isLoggedIn ? (
                            <Collapse isOpen={this.state.isOpen} navbar className="justify-content-center header-nav-collapse">
                                <button
                                    type="button"
                                    className="header-menu-close"
                                    onClick={this.closeMenu}
                                    aria-label={this.props.intl.formatMessage({ id: 'close', defaultMessage: 'Close' })}
                                >
                                    <FontAwesome name="times" />
                                </button>
                                <Menu closeMenu={this.closeMenu} />
                            </Collapse>
                        ) : null}

                        <Nav className="ml-auto">
							{this.props.cartItems.length > 0 && (
								<NavItem>
									<Link to="/cart" className="nav-link d-block text-primary"><FontAwesome name="shopping-basket" size="lg" /> <Badge color="primary" pill>{this.props.cartItems.length}</Badge></Link>
								</NavItem>
							)}
							{!isLoggedIn ? (
								<NavItem>
									<Link to="/user/login" className="nav-link d-block text-dark"><FontAwesome name="user-circle" size="lg" /></Link>
								</NavItem>
							) : null}
                        </Nav>

                        {isLoggedIn ? <NavbarToggler onClick={this.toggle} /> : null}
                    </Navbar>
                </Container>
            </div>
        );
    }
}
// <FormattedMessage id="accountMy" defaultMessage="My account" /> ({`${this.props.user.firstName} ${this.props.user.lastName}`})

function mapStateToProps(store, props) {
    return {
        errors: store.error.data,
        user: store.users.user,
        redirectRoute: store.app.redirect,
        redirectIndex: store.app.redirectIndex,
		cartItems: getCartItems(store),
    };
}

Header.defaultProps = {
    user: null,
    redirectRoute: '',
    redirectIndex: 0,
	cartItems: [],
};
Header.propTypes = {
    dispatch: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    search: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    errors: PropTypes.array.isRequired,
    user: PropTypes.object,
    redirectRoute: PropTypes.string,
    redirectIndex: PropTypes.number,
	cartItems: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(withRouter(injectIntl(Header)));
